import { getAxiosClient } from "../axios";

export const AddOrderEnveloppes = async (data) => {
  const axiosClient = await getAxiosClient();
console.log(data)
  return await axiosClient
    .put(`/enveloppes`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error", error);
      return Promise.reject(error);
    });
};